import { render, staticRenderFns } from "./ConfigureSettingsNew.vue?vue&type=template&id=2c99eb9d&scoped=true"
import script from "./ConfigureSettingsNew.vue?vue&type=script&lang=js"
export * from "./ConfigureSettingsNew.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettingsNew.vue?vue&type=style&index=0&id=2c99eb9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99eb9d",
  null
  
)

export default component.exports